import wimsPulse from './wimsPulse';

export const wimsPulseService = wimsPulse;
